// components/AuthGuard.js
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const PUBLIC_ROUTES = [
  '/verifyemail',
  '/statsElsa@1973',
  '/2fa',
  '/onboarding',
  '/connexion',
];

export default function AuthGuard() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Ici location.pathname est TOUJOURS à jour car ce composant
    // est rendu DANS le RouterContext
    if (PUBLIC_ROUTES.includes(location.pathname)) return;

    const token      = localStorage.getItem("token");
    const storedUser = localStorage.getItem("user");
    const hasSeenOnboarding = localStorage.getItem('hasSeenOnboarding');

    if (!hasSeenOnboarding && (!token || !storedUser)) {
      navigate('/onboarding');
      return;
    }

    if (!token || !storedUser) {
      navigate('/connexion');
    }

  }, [location.pathname, navigate]);

  return null; // pas de rendu
}